var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-overlay',{attrs:{"show":_vm.show,"rounded":"sm","blur":"1px"},scopedSlots:_vm._u([{key:"overlay",fn:function(){return [_c('div',{staticClass:"text-center"},[_c('b-icon',{attrs:{"icon":_vm.icon,"font-scale":"3","animation":"cylon"}}),_c('p',[_vm._v(_vm._s(_vm.text))])],1)]},proxy:true}])},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }